import { omit } from 'lodash'

import { PlotlineVirtualType } from '#/@types/backend'
import { Icon } from '#/components/Icon'

type Props = {
  color?: string
  virtual_type: { type: PlotlineVirtualType }
}

export const ChartBuilderIcon = ({ color, virtual_type }: Props) => {
  const type = virtual_type.type
  const height = 25
  const margin = 2

  const style = {
    fill: color,
    height,
    margin,
  }

  if (type.match(/sanitary_protocol./)) {
    return <Icon name="health-protocol" style={style} />
  }

  if (type.match(/health.*/)) {
    return <Icon name="plotline-health" style={style} />
  }

  if (type.match(/handling.*/)) {
    return <Icon name="plotline-handling" style={style} />
  }

  if (type.match(/reproduction.*/)) {
    return <Icon name="plotline-reproduction" style={style} />
  }

  if (type.match(/discard.*/)) {
    return <Icon name="plotline-discard" style={style} />
  }

  if (type.match(/arrival.*/)) {
    return <Icon name="plotline-arrival" style={style} />
  }

  if (type === 'batch.animal.assignment') {
    return <Icon name="replace" style={style} />
  }

  if (type.match(/milk.quality.*/)) {
    return <Icon name="milk-quality" style={{ ...omit(style, 'fill'), stroke: color }} />
  }

  if (type.match(/rumination_variation.increase.*/)) {
    return <Icon name="plotline-rumination-increase" style={style} />
  }

  if (
    type.match(/rumination_variation.decrease.*/) ||
    type.match(/rumination_threshold.danger.*/)
  ) {
    return <Icon name="plotline-rumination-decrease" style={style} />
  }

  if (type.match(/diet/i) || type.match(/rumination*/i)) {
    return <Icon name="plotline-diet" style={style} />
  }

  if (type.match(/feed_delivery/)) {
    return <Icon name="tractor" style={{ ...omit(style, 'fill'), stroke: color }} />
  }

  // Ordenha
  if (type === 'milk.batch.milking') {
    return <Icon name="production" style={style} />
  }

  return <Icon name={type as any} style={style} />
}
